import React, { useEffect } from "react";
import "../assets/stylesheets/Terms.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useBrand } from "../branding/BrandContext";

export default function Terms() {
  const brand = useBrand();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (

        <>
          <Header />
    <div className="termsPage">
      <section className="termsContent">
        <div className="container narrow">

          <h1>Terms & Conditions</h1>
          <p className="tagline">
            {brand.brandName}™ Homeowner User Agreement
          </p>
          <p><strong>Last Updated:</strong> 12/15/2025</p>

          <h2>1. Introduction</h2>
          <p>
            Welcome to {brand.brandName}™, a service operated by {brand.legalEntityName} (“Company,”
            “we,” “us,” or “our”). {brand.brandName} operates a digital
            marketplace platform that may connect homeowners with independent
            home service professionals (“Service Providers”).
          </p>
          <p>
            These Terms & Conditions govern your access to and use of the
            {brand.brandName} website, tools, surveys, AI-generated summaries,
            and related services (collectively, the “Service”).
          </p>
          <p>
            By submitting a project request, completing a form, or otherwise
            accessing or using the Service, you acknowledge and agree to be
            legally bound by these Terms and our Privacy Policy.
            If you do not agree, you should discontinue use of the Service.
          </p>

          <h2>2. Nature of the Service</h2>
          <p>
            {brand.brandName} operates solely as a marketing, technology,
            and lead-generation platform. We may collect project-related
            information and may provide such information to participating
            independent Service Providers.
          </p>

          <p>{brand.brandName}:</p>
          <ul>
            <li>Does not perform home improvement services</li>
            <li>Does not employ, supervise, or control Service Providers</li>
            <li>Does not guarantee project completion or outcomes</li>
            <li>Is not a party to any contract between you and a Service Provider</li>
          </ul>

          <p>
            Any agreement for services may be entered into solely between you
            and a selected Service Provider. {brand.brandName} disclaims any responsibility
            arising from such agreements.
          </p>

          <h2>3. Project Information & Accuracy</h2>
          <p>
            You agree to provide accurate, complete, and truthful information
            when submitting a project request.
          </p>
          <p>
            {brand.brandName} may rely on the information you provide to facilitate
            potential matching with Service Providers. We are not responsible
            for errors, omissions, or inaccuracies in user-submitted information.
          </p>

          <h2>4. No Guarantee of Quotes or Availability</h2>
          <p>
            Submission of a request does not guarantee:
          </p>
          <ul>
            <li>You will receive a call, estimate, or quote</li>
            <li>A Service Provider operates in your area</li>
            <li>A Service Provider will accept your project</li>
            <li>Pricing, timelines, or availability</li>
          </ul>

          <p>
            Service Providers independently determine whether to contact you,
            provide estimates, or offer services.
          </p>

          <h2>5. Communication Consent</h2>
          <p>
            By submitting your information, you expressly consent to being
            contacted by {brand.brandName} and/or one or more Service Providers
            via phone call, text message (including SMS), email, or other
            electronic communication methods.
          </p>
          <p>
            Such communications may use automated technology.
            Message and data rates may apply.
            Consent is not a condition of purchasing any goods or services.
          </p>
          <p>
            You may opt out of certain communications in accordance with
            applicable law.
          </p>

          <h2>6. Service Provider Responsibility</h2>
          <p>
            Service Providers are independent businesses and are not employees,
            agents, representatives, joint venturers, or partners of {brand.brandName}.
          </p>
          <p>
            {brand.brandName} does not guarantee:
          </p>
          <ul>
            <li>Licensing or insurance status</li>
            <li>Quality of workmanship</li>
            <li>Pricing fairness</li>
            <li>Project completion timelines</li>
            <li>Compliance with local laws</li>
          </ul>
          <p>
            You are solely responsible for conducting independent due diligence
            prior to entering into any agreement with a Service Provider.
          </p>

          <h2>7. Disputes Between Users and Service Providers</h2>
          <p>
            Any dispute regarding services, payments, workmanship, or performance
            may be resolved directly between you and the applicable Service Provider.
          </p>
          <p>
            {brand.brandName} disclaims any obligation to mediate, resolve,
            reimburse, or otherwise participate in disputes arising from
            services performed by Service Providers.
          </p>

          <h2>8. Intellectual Property</h2>
          <p>
            All website content, branding, workflows, software systems,
            AI-generated summaries, proprietary algorithms, and related
            intellectual property remain the exclusive property of
            {brand.legalEntityName}.
          </p>
          <p>
            Unauthorized reproduction, reverse engineering,
            redistribution, or misuse of any portion of the platform
            is prohibited.
          </p>

          <h2>9. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, {brand.brandName} shall not be liable
            for any indirect, incidental, consequential, special, exemplary,
            or punitive damages arising out of or relating to use of the Service.
          </p>
          <p>
            {brand.brandName}’s aggregate liability, if any, shall not exceed $100.
          </p>
          <p>
            The Service is provided “AS IS” and “AS AVAILABLE”
            without warranties of any kind, whether express or implied.
          </p>

          <h2>10. Modifications to the Service</h2>
          <p>
            We may modify, suspend, discontinue, or update any portion of the Service
            at any time, with or without notice.
          </p>
          <p>
            Continued use of the Service after modifications constitutes acceptance
            of revised Terms.
          </p>

          <h2>11. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of the State of
            [Insert State], without regard to conflict of law principles.
          </p>
          <p>
            Subject to the arbitration provision below, disputes shall be
            resolved within that jurisdiction.
          </p>

          <h2>12. Contact Information</h2>
          <p>
            <strong>{brand.legalEntityName}</strong><br />
            Email: help@homehelper.biz<br />
            Website: {brand.consumerBaseUrl}
          </p>

          <h2>13. AI-Generated Project Summary Disclaimer</h2>
          <p>
            {brand.brandName} may use artificial intelligence systems to generate
            structured project summaries, reports, or estimates based on
            submitted information.
          </p>
          <p>
            AI-generated outputs are informational only and may contain errors
            or omissions. They do not constitute professional advice,
            binding estimates, engineering analysis, or guarantees.
          </p>
          <p>
            Users remain responsible for independently verifying
            all project details.
          </p>

          <h2>14. Arbitration Agreement & Class Action Waiver</h2>
          <p>
            Any dispute, claim, or controversy arising out of or relating to
            these Terms or use of the Service may be resolved through binding
            arbitration administered by the American Arbitration Association.
          </p>
          <p>
            This arbitration agreement is governed by the Federal Arbitration Act (FAA).
          </p>
          <ul>
            <li>You waive the right to a trial by jury.</li>
            <li>You waive the right to participate in a class action.</li>
            <li>Claims must be brought individually.</li>
          </ul>

          <h2>15. California Consumer Privacy Addendum (CCPA / CPRA)</h2>
          <p>
            California residents may have rights under the CCPA and CPRA.
            Please refer to the Privacy Policy for additional disclosures.
          </p>

          <h2>16. Short-Form Lead Form Consent Language</h2>
          <div style={{border: "1px solid #ccc", padding: "15px", marginTop: "10px"}}>
            ☐ By clicking “Submit,” I agree to the {brand.brandName}™ Terms & Conditions
            and Privacy Policy and consent to be contacted by {brand.brandName} and
            one or more service providers via phone, text message (including
            automated dialing systems), and email regarding my project.
            Consent is not a condition of purchase.
          </div>

          <p className="acknowledgment">
            By submitting a project request or using the Service, you acknowledge
            that you have read, understood, and agree to these Terms & Conditions.
          </p>

        </div>
      </section>
    </div>
    <Footer />
    </>
  );
}
